<template>
  <div :style="containerStyle">
    <div :style="dividerStyle"></div>
  </div>
</template>
<script lang="ts" setup>
import { computed } from "vue"

const props = withDefaults(
  defineProps<{
    mode?: "horizontal" | "vertical"
    padding?: number
    margin?: number
    color?: string
  }>(),
  {
    mode: "horizontal",
    padding: 0,
    margin: 0,
    color: "#efeff4",
  }
)

const dividerStyle = computed(() => {
  if (props.mode == "vertical") {
    return {
      width: "1px",
      height: "100%",
      "background-color": props.color,
    }
  } else {
    return {
      width: "100%",
      height: "1px",
      "background-color": props.color,
    }
  }
})

const containerStyle = computed(() => {
  if (props.mode == "vertical") {
    return {
      height: "100%",
      padding: `${props.padding}px ${props.margin}px ${props.padding}px ${props.margin}px`,
      "box-sizing": "border-box",
    }
  } else {
    return {
      width: "100%",
      padding: `${props.margin}px ${props.padding}px ${props.margin}px ${props.padding}px`,
      "box-sizing": "border-box",
    }
  }
})
</script>
<style scoped></style>
